import { AxiosInstance, AxiosRequestConfig } from 'axios'
import storage from 'commons/utils/storage'
import { decode } from 'commons/utils/auth/jwt'
import { EventType, sendEvent } from 'commons/utils/event'
import { INVALID_USER_MESSAGE, LOGOUT_ROUTE } from 'commons/constants/app'
import { REFRESH_TOKEN, TOKEN } from 'commons/constants/store'
import { isTokenExpired } from 'commons/utils/auth/auth'
import authApi from 'services/auth'

type RequestRetryCallBack = (token: string) => void

let isRefreshing = false
let subscribers: RequestRetryCallBack[] = []

function subscribeTokenRefresh(cb: RequestRetryCallBack) {
  subscribers.push(cb)
}

function onRefreshed(token: string) {
  subscribers.map(cb => cb(token))
  subscribers = []
}

const logoutUser = () => location.assign(LOGOUT_ROUTE)

function tryToRefreshToken(client: AxiosInstance, requestToRetry: AxiosRequestConfig) {
  const refreshToken: string = storage.get(REFRESH_TOKEN)
  const decodedRefreshToken = decode(refreshToken)

  if (isTokenExpired(decodedRefreshToken?.exp)) {
    logoutUser()
    return Promise.reject({ status: 401, message: INVALID_USER_MESSAGE })
  }

  if (!isRefreshing) {
    isRefreshing = true
    authApi
      .refreshToken(refreshToken)
      .then(newToken => {
        storage.add(TOKEN, newToken)
        sendEvent(EventType.SET_USER, newToken)

        onRefreshed(newToken)
        isRefreshing = false
      })
      .catch(() => {
        logoutUser()
      })
  }

  const requestSubscribers = new Promise(resolve => {
    subscribeTokenRefresh(token => {
      requestToRetry.headers = { ...requestToRetry.headers, Authorization: token }
      resolve(client(requestToRetry))
    })
  })

  return requestSubscribers
}

export { tryToRefreshToken }
